"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The PageAccessControl model module.
 * @module model/PageAccessControl
 * @version 3.0
 */
var PageAccessControl = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>PageAccessControl</code>.
   * @alias module:model/PageAccessControl
   */
  function PageAccessControl() {
    _classCallCheck(this, PageAccessControl);
    PageAccessControl.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(PageAccessControl, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>PageAccessControl</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PageAccessControl} obj Optional instance to populate.
     * @return {module:model/PageAccessControl} The populated <code>PageAccessControl</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new PageAccessControl();
        if (data.hasOwnProperty('linkId')) {
          obj['linkId'] = _ApiClient["default"].convertToType(data['linkId'], 'Number');
        }
        if (data.hasOwnProperty('userId')) {
          obj['userId'] = _ApiClient["default"].convertToType(data['userId'], 'Number');
        }
        if (data.hasOwnProperty('pageId')) {
          obj['pageId'] = _ApiClient["default"].convertToType(data['pageId'], 'Number');
        }
        if (data.hasOwnProperty('actions')) {
          obj['actions'] = _ApiClient["default"].convertToType(data['actions'], 'String');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }
        if (data.hasOwnProperty('statusDate')) {
          obj['statusDate'] = _ApiClient["default"].convertToType(data['statusDate'], 'Date');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PageAccessControl</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PageAccessControl</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['actions'] && !(typeof data['actions'] === 'string' || data['actions'] instanceof String)) {
        throw new Error("Expected the field `actions` to be a primitive type in the JSON string but got " + data['actions']);
      }
      // ensure the json data is a string
      if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
        throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} linkId
 */
PageAccessControl.prototype['linkId'] = undefined;

/**
 * @member {Number} userId
 */
PageAccessControl.prototype['userId'] = undefined;

/**
 * @member {Number} pageId
 */
PageAccessControl.prototype['pageId'] = undefined;

/**
 * @member {String} actions
 */
PageAccessControl.prototype['actions'] = undefined;

/**
 * @member {String} status
 */
PageAccessControl.prototype['status'] = undefined;

/**
 * @member {Date} statusDate
 */
PageAccessControl.prototype['statusDate'] = undefined;
var _default = exports["default"] = PageAccessControl;